module.exports = __webpack_public_path__ + "img/TSY_03_02.cf70c760.png";